import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './SavedFeaturedProfile.scss';
import { deleteRequest } from '../../requestUtils';
var renderRoles = function renderRoles(name, roles) {
  if (roles && roles.length > 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "role"
    }, /*#__PURE__*/React.createElement("div", {
      className: "body-text-2 medium-weight role-name"
    }, name), roles.map(function (role) {
      return /*#__PURE__*/React.createElement("span", {
        key: role[0],
        className: "badge small blue-light"
      }, role[0], role[1] && /*#__PURE__*/React.createElement("span", {
        className: "heading-extra-text ms-2"
      }, role[1]));
    }));
  }
  return null;
};
var SavedFeaturedProfile = /*#__PURE__*/function (_Component) {
  function SavedFeaturedProfile(props) {
    var _this;
    _classCallCheck(this, SavedFeaturedProfile);
    _this = _callSuper(this, SavedFeaturedProfile, [props]);
    _this.state = {
      hidden: false,
      email: props.email || '',
      validForm: false
    };
    _this.handleDeleteConsultant = _this.handleDeleteConsultant.bind(_this);
    return _this;
  }
  _inherits(SavedFeaturedProfile, _Component);
  return _createClass(SavedFeaturedProfile, [{
    key: "handleDeleteConsultant",
    value: function handleDeleteConsultant() {
      var _this2 = this;
      var _this$props = this.props,
        saveConsultantUrl = _this$props.saveConsultantUrl,
        csrfToken = _this$props.csrfToken;
      deleteRequest(saveConsultantUrl, csrfToken).then(function (response) {
        _this2.setState({
          hidden: true
        });
        if (response.data.redirect_url) {
          window.location = response.data.redirect_url;
        }
      });
    }
  }, {
    key: "renderOverview",
    value: function renderOverview() {
      var _this$props2 = this.props,
        featuredProfile = _this$props2.featuredProfile,
        userLink = _this$props2.userLink;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-flex-8"
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mr-8 mb-4 transform-name"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header-1"
      }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        className: "table-row"
      }, /*#__PURE__*/React.createElement("a", {
        href: userLink,
        className: "header-1"
      }, featuredProfile.name)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("button", {
        id: "remove-consultant",
        className: "remove-consultants",
        onClick: this.handleDeleteConsultant
      }, "Remove"))))), featuredProfile.city && /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 muted-gray-text"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-map-marker-alt me-3"
      }), /*#__PURE__*/React.createElement("span", null, featuredProfile.city))))));
    }
  }, {
    key: "renderSkills",
    value: function renderSkills() {
      var _this$props3 = this.props,
        featuredProfile = _this$props3.featuredProfile,
        projectTags = _this$props3.projectTags;
      var criteria = projectTags.aoe || [];
      if (projectTags.ta) {
        criteria = criteria.concat(projectTags.ta);
      }
      if (projectTags.therapy) {
        criteria = criteria.concat(projectTags.therapy);
      }
      var skills = featuredProfile.area_of_expertises.concat(featuredProfile.therapeutic_areas.concat(featuredProfile.therapies)).sort(function (a, b) {
        return (criteria.includes(a) ? 0 : 1) - (criteria.includes(b) ? 0 : 1);
      });
      if (skills && skills.length > 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: "skill"
        }, skills.map(function (skill) {
          return /*#__PURE__*/React.createElement("span", {
            key: skill,
            className: "badge small ".concat(criteria.includes(skill) ? 'purple-base' : 'blue-light')
          }, skill);
        }));
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        featuredProfile = _this$props4.featuredProfile,
        isRep = _this$props4.isRep,
        truncated = _this$props4.truncated;
      var hidden = this.state.hidden;
      return hidden ? '' : [/*#__PURE__*/React.createElement("div", {
        className: "consultant-card"
      }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        className: "consultant-info",
        valign: "top"
      }, this.renderOverview(isRep), /*#__PURE__*/React.createElement("div", {
        className: "tags"
      }, renderRoles('', featuredProfile.higher_level_roles.slice(0, 3))), /*#__PURE__*/React.createElement("div", {
        className: "heading"
      }, "Expertise Areas"), !truncated && /*#__PURE__*/React.createElement("div", {
        className: "tags"
      }, this.renderSkills())))))];
    }
  }]);
}(Component);
SavedFeaturedProfile.propTypes = {
  projectTags: PropTypes.shape({}).isRequired,
  featuredProfile: PropTypes.shape({}).isRequired,
  csrfToken: PropTypes.string.isRequired,
  email: PropTypes.string,
  userLink: PropTypes.string.isRequired,
  isRep: PropTypes.bool,
  truncated: PropTypes.bool,
  saveConsultantUrl: PropTypes.string.isRequired
};
SavedFeaturedProfile.defaultProps = {
  truncated: false
};
export default SavedFeaturedProfile;